import { __awaiter, __generator } from "tslib";
import { PauseNotAllowedError, TypeErrors } from './errors';
import { Task, } from './task';
export var AgentStatus;
(function (AgentStatus) {
    AgentStatus["Online"] = "online";
    AgentStatus["Offline"] = "offline";
    AgentStatus["Pause"] = "pause";
    AgentStatus["BreakOut"] = "break_out";
})(AgentStatus || (AgentStatus = {}));
export var ChannelState;
(function (ChannelState) {
    ChannelState["Waiting"] = "waiting";
    ChannelState["Distribute"] = "distribute";
    ChannelState["Offering"] = "offering";
    ChannelState["Answered"] = "answered";
    ChannelState["Active"] = "active";
    ChannelState["Bridged"] = "bridged";
    ChannelState["Hold"] = "hold";
    ChannelState["Missed"] = "missed";
    ChannelState["WrapTime"] = "wrap_time";
    ChannelState["Processing"] = "processing";
    ChannelState["Transfer"] = "transfer";
    ChannelState["Form"] = "form";
})(ChannelState || (ChannelState = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["Call"] = "call";
    ChannelType["Email"] = "email";
    ChannelType["Chat"] = "chat";
    ChannelType["Job"] = "task";
})(ChannelType || (ChannelType = {}));
var Agent = /** @class */ (function () {
    function Agent(client, info) {
        this.client = client;
        this.info = info;
        this.task = new Map();
        this._channels = new Map();
        this.initChannels(info.channels);
        this._listOfflineMembers = null;
        this.waitingListChats = [];
        this.waitingListCalls = [];
        this.lastStatusChange = Date.now() - this.info.status_duration * 1000;
    }
    Object.defineProperty(Agent.prototype, "agentId", {
        get: function () {
            return this.info.agent_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "onDemand", {
        get: function () {
            return this.info.on_demand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "status", {
        get: function () {
            return this.info.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "statusPayload", {
        get: function () {
            return this.info.status_payload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "isAdmin", {
        get: function () {
            return this.info.is_admin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "isSupervisor", {
        get: function () {
            return this.info.is_supervisor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "team", {
        get: function () {
            return this.info.team;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "supervisor", {
        get: function () {
            return this.info.supervisor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "auditor", {
        get: function () {
            return this.info.auditor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "channels", {
        get: function () {
            return Array.from(this._channels.values());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "channel", {
        get: function () {
            return this._channels.get(ChannelType.Call);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Agent.prototype, "stateDuration", {
        get: function () {
            return Math.round((Date.now() - this.lastStatusChange) / 1000);
        },
        enumerable: false,
        configurable: true
    });
    // todo need refactor
    Agent.prototype.setWaitingList = function (e) {
        if (e) {
            var list = e.list;
            this.waitingListCalls.length = 0;
            this.waitingListChats.length = 0;
            for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                var el = list_1[_i];
                switch (el.channel) {
                    case ChannelType.Call:
                        this.waitingListCalls.push(el);
                        break;
                    case ChannelType.Chat:
                        this.waitingListChats.push(el);
                        break;
                    default:
                }
            }
        }
    };
    Agent.prototype.deleteWaitingAttempt = function (e) {
        if (e) {
            var attemptId = e.attempt_id;
            if (!removeWaitingList(this.waitingListCalls, attemptId)) {
                removeWaitingList(this.waitingListChats, attemptId);
            }
        }
    };
    Agent.prototype.interceptAttempt = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request("cc_intercept_attempt", {
                        attempt_id: id,
                        agent_id: this.agentId,
                    })];
            });
        });
    };
    Agent.prototype.onChannelEvent = function (e) {
        var task;
        switch (e.status) {
            case ChannelState.Distribute:
                var distributeEvent = e;
                if (!distributeEvent) {
                    throw new Error('bad event');
                }
                task = new Task(this.client, e, distributeEvent.distribute);
                this.task.set(task.id, task);
                if (task.agentChannelId) {
                    switch (task.channel) {
                        case ChannelType.Call:
                            var call = this.client.callById(task.agentChannelId);
                            if (call && !call.task) {
                                call.task = task;
                            }
                            break;
                        case ChannelType.Chat:
                            var chat = this.client.conversationById(task.agentChannelId);
                            if (chat && !chat.task) {
                                chat.task = task;
                            }
                            break;
                        default:
                    }
                }
                break;
            case ChannelState.Offering:
                var evOffering = e;
                task = this.task.get(e.attempt_id);
                if (task) {
                    task.setOffering(evOffering);
                }
                break;
            case ChannelState.Bridged:
                var bridged = e;
                task = this.task.get(bridged.attempt_id);
                if (task) {
                    task.setBridged(bridged);
                }
                break;
            case ChannelState.Transfer:
                var transfer = e;
                task = this.task.get(transfer.to_attempt_id);
                if (task) {
                    this.task.delete(task.id);
                    task.id = transfer.attempt_id;
                    task.setTransferred(transfer.distribute);
                    this.task.set(task.id, task);
                }
                break;
            case ChannelState.Answered:
                task = this.task.get(e.attempt_id);
                if (task) {
                    task.answeredAt = e.timestamp;
                }
                break;
            case ChannelState.Form:
                var formEvent = e;
                task = this.task.get(e.attempt_id);
                if (task) {
                    task.form = formEvent.form || null;
                }
                return; // todo
            case ChannelState.Missed:
                if (e.attempt_id) {
                    task = this.task.get(e.attempt_id);
                    if (task) {
                        task.stopAt = e.timestamp;
                        var missedEvent = e;
                        if (!missedEvent) {
                            throw new Error('bad event');
                        }
                        task.setMissed();
                        this.setChannelStateTimeout(e, missedEvent.missed.timeout);
                        this.task.delete(e.attempt_id);
                        this.client.reportingChannelTask(task);
                        return task;
                    }
                }
                break;
            case ChannelState.WrapTime:
                if (e.attempt_id) {
                    var wrapTimeEvent = e;
                    if (!wrapTimeEvent) {
                        throw new Error('bad event');
                    }
                    task = this.task.get(e.attempt_id);
                    this.task.delete(e.attempt_id);
                    this.client.reportingChannelTask(task);
                }
                break;
            case ChannelState.Processing:
                if (e.attempt_id) {
                    var processingEvent = e;
                    if (!processingEvent) {
                        throw new Error('bad event');
                    }
                    task = this.task.get(e.attempt_id);
                    if (task) {
                        task.setProcessing(e.timestamp, processingEvent.processing);
                        this.setChannelStateTimeout(e, processingEvent.processing.timeout || 0);
                        return task;
                    }
                }
                break;
            // TODO
            case ChannelState.Waiting:
                if (e.attempt_id) {
                    task = this.task.get(e.attempt_id);
                    if (task) {
                        task.setClosed(e.timestamp);
                        this.task.delete(e.attempt_id);
                        this.client.reportingChannelTask(task);
                    }
                }
                break;
            default:
            // throw new Error("not found task")
        }
        this.setChannelState(e);
        if (task) {
            task.setState(e.status);
            return task;
        }
        else {
            return undefined;
        }
    };
    Agent.prototype.online = function (channels, onDemand) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.agentSetOnline(this.agentId, channels, onDemand)];
            });
        });
    };
    Agent.prototype.waiting = function (channel) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.agentSetWaiting(this.agentId, channel)];
            });
        });
    };
    Agent.prototype.pause = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.agentSetPause(this.agentId, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1.id === TypeErrors.PauseNotAllow) {
                            return [2 /*return*/, new PauseNotAllowedError(e_1.detail)];
                        }
                        return [2 /*return*/, e_1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Agent.prototype.offline = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.agentSetOffline(this.agentId)];
            });
        });
    };
    Agent.prototype.setStatus = function (e) {
        if (e.status === AgentStatus.Online) {
            this.info.on_demand = e.on_demand || false;
            this.initChannels(e.channels);
        }
        this.info.status = e.status;
        this.info.status_payload = e.status_payload ? e.status_payload : null;
        this.lastStatusChange = Date.now();
    };
    Agent.prototype.directMember = function (memberId, communicationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request("cc_member_direct", {
                        agent_id: this.agentId,
                        member_id: memberId,
                        communication_id: communicationId,
                    })];
            });
        });
    };
    Agent.prototype.offlineMembers = function (q, page, perPage) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.client.request("cc_fetch_offline_members", {
                                agent_id: this.agentId,
                                page: page,
                                q: q,
                                per_page: perPage,
                            })];
                    case 1:
                        _a._listOfflineMembers = (_b.sent());
                        return [2 /*return*/, this._listOfflineMembers];
                }
            });
        });
    };
    Agent.prototype.hasTask = function (task) {
        return this.task.has(task.id);
    };
    Agent.prototype.initChannels = function (channels) {
        for (var _i = 0, channels_1 = channels; _i < channels_1.length; _i++) {
            var c = channels_1[_i];
            this._channels.set(c.channel, c);
        }
    };
    Agent.prototype.getChannel = function (name) {
        return this._channels.get(name);
    };
    Agent.prototype.setChannelState = function (e) {
        var chan = this.getChannel(e.channel);
        if (chan) {
            chan.state = e.status;
            chan.joined_at = e.timestamp;
            chan.timeout = undefined;
        }
    };
    Agent.prototype.setChannelStateTimeout = function (e, timeout) {
        var channel = this.getChannel(e.channel);
        if (channel) {
            channel.state = e.status;
            channel.timeout = timeout;
            channel.joined_at = e.timestamp;
        }
    };
    return Agent;
}());
export { Agent };
function removeWaitingList(list, attemptId) {
    for (var i = 0; i < list.length; i++) {
        if (list[i].attempt_id === attemptId) {
            list.splice(i, 1);
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=agent.js.map